import React, { ReactNode, useEffect } from "react";
import { Provider } from "react-redux";
import configStore, { ConfigContext } from "./configStore";
import "./sshUsersMsgReceivers";
import { requestListSSHUsers } from "./sshUsersMsgSenders";

interface IProps {
    appID?: string;
    children: ReactNode;
}

function ConfigProvider(props: IProps) {
    return (
        <Provider store={configStore} context={ConfigContext}>
            {props.children}
        </Provider>
    );
}

export default ConfigProvider;
